module.exports = __webpack_public_path__ + "img/home_sanku.2ac5ceb2.png";